module.exports = new __parcel__URL__("Strategic.ce23e37f.jpg").toString();